import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllSkillMaps(_obj, params) {
    const res = await axios.get(`api/skills/ai/`, { params });
    return res.data;
  },

  async getSkillMap(_obj, id) {
    const res = await axios.get(`api/skills/ai/${id}/`);
    return res.data;
  },

  async createSkillMap(_obj, data) {
    return axios.post(`api/skills/ai/`, data);
  },

  async updateSkillMap(_obj, { id, data }) {
    return axios.patch(`api/skills/ai/${id}/`, data);
  },
  async updateSkillMapActiveStatus(_obj, { id, data }) {
    return axios.patch(`api/skills/ai/${id}/update-is-active/`, data);
  },

  async deleteSkillMap(_obj, id) {
    return axios.delete(`api/skills/ai/${id}/`);
  },
};

export const aiSkills = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
